import React from 'react';
import classnames from 'classnames';
import {formattingDate} from "../../../utils/formatting";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text5 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, rightsRegistryDate} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(rightsRegistryDate) && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>תאריך: </span>
          <span>{formattingDate(rightsRegistryDate)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text5;
